import gql from 'graphql-tag';

export const getAcademicPlanProgress = gql`
  query getAcademicPlanProgress {
    student {
      academic {
        campusDesc
        progDesc
      }
      profile {
        studentCode
      }
      academicPlanProgress {
        requiredCourses {
          approved
          pending
          total
        }
        credits {
          required {
            approved
            pending
            total
          }
          optional {
            approved
            pending
            total
          }
          total
        }
      }
    }
  }
`;
